import { defaultPageProps, defaultProps } from '../../../app/browser/analyticsDefaultProperties';

const activityLocation = 'SP: Link a business';

export default {
  page: {
    name: activityLocation,
    properties: defaultPageProps,
  },
  elements: {
    'back-to-list-btn': {
      click: {
        name: 'Item Clicked',
        properties: {
          activityLocation,
          ...defaultProps,
          description: 'Clicks on back link',
        },
      },
    },
    'error-message-help': {
      click: {
        name: 'Item Clicked',
        properties: {
          activityLocation,
          ...defaultProps,
          description: 'Link ads business help',
        },
      },
    },
    'forgot-info-link': {
      click: {
        name: 'Item Clicked',
        properties: {
          activityLocation,
          ...defaultProps,
          description: 'Recover username or password',
        },
      },
    },
    help: {
      click: {
        name: 'Item Clicked',
        properties: {
          activityLocation,
          ...defaultProps,
          description: 'Link ads business help',
        },
      },
    },
    phone: {
      click: {
        name: 'Item Clicked',
        properties: {
          activityLocation,
          ...defaultProps,
          description: 'Call helpline',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/home/browser/linkABusinessAnalytics.js